import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../../context/Provider";
import { GlobalContext } from "../../../../global/context/Provider";
import {
    multiTabDataMisLaboratorios
} from "../../../../global/utils/multiTabData";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import { showModal } from "../../../context/Actions/modal/modal";
import camelize from "../../../../global/utils/camelize";
import { IoChevronDown } from "react-icons/io5";
import "./MultitabMobileMisLaboratorios.css";

const MultitabMobileMisLaboratorios = ({ posicionMultitab, valor, datos, onChange }) => {
  const { modalDispatch, selectDropDownState } = useContext(PortalContext);
  const { authState } = useContext(GlobalContext);

  const handleOpenModalFamiliares = () => {
    showModal(
      "Genericos/ModalSeleccionarFamiliar/ModalSeleccionarFamiliar",
      {
        familiares: datos,
        onSelectFamiliar: onChange,
      },
      [],
      "bottomSheet",
      false
    )(modalDispatch);
  };

  const getNombrePacienteActual = () => {
    if (selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido) {
      return camelize(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.paciente
          .nombre
      );
    }
    return camelize(authState?.auth?.data?.paciente?.nombre || "");
  };

  return (
    <React.Fragment>
      <div className="ptur-multitabMobileMisLaboratorios-container">
        <div className="ptur-multitabMobileMisLaboratorios-selector">
          <p className="ptur-multitabMobileMisLaboratorios-texto-viendo">
            Viendo estudios de{" "}
            <button
              className="ptur-multitabMobileMisLaboratorios-nombre-btn"
              onClick={handleOpenModalFamiliares}
            >
              <span>{getNombrePacienteActual()}</span>
              <IoChevronDown size={16} />
            </button>
          </p>
        </div>
      </div>
      <div className="ptur-multitabMobileMisLaboratorios-componente-container"></div>
    </React.Fragment>
  );
};

export default MultitabMobileMisLaboratorios;
